module.exports = __webpack_public_path__ + "static/media/jetSkiing.f0208a4d.jpg";